import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import ChapterTable from './components/ChapterTable';
import UserManagement from './components/UserManagement';
import DeleteUser from './components/DeleteUser';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Dashboard from './pages/Dashboard';
import AlertScheduleTabs from './components/AlertScheduleTabs';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/logout" element={<Logout />} />

        {/* Protected Dashboard with Nested Routes */}
        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />}>
          <Route path="chapters" element={<ChapterTable />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="delete-user" element={<DeleteUser />} />
          <Route path="alert-schedule" element={<AlertScheduleTabs />} />
        </Route>

        {/* 404 Fallback */}
        <Route path="*" element={<h2>404 - Page Not Found</h2>} />
      </Routes>
    </Router>
  );
}

export default App;
